var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "infoBox" }, [
    _c(
      "div",
      {
        staticStyle: {
          position: "absolute",
          transform: "translate(-47%, -286%)",
          "z-index": "10",
        },
        style: {
          left: _vm.param.x + "px",
          top: _vm.param.y + "px",
        },
      },
      [
        _c("div", { staticClass: "warn" }, [
          _c("p", [_vm._v(_vm._s(_vm.param.name))]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }